import { format, getTime, formatDistanceToNow } from 'date-fns';
import { ko } from 'date-fns/locale'
import { formatInTimeZone } from 'date-fns-tz'

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy p');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy-MM-dd HH:mm:ss', { timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTFile(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd (EE) HH:mm', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

function KRCorrectionFormatString(date, dateFormat) {
  if(date) {
    const dateTZCorrection = new Date(date.getTime() + (date.getTimezoneOffset() > 0 ? date.getTimezoneOffset() * 60000 : 0));
    return format(dateTZCorrection, dateFormat, { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTContract(date) {
  if(date) {
    return KRCorrectionFormatString(new Date(date), 'yyyy.MM.dd');
  }
}

export function fKrKSTPayment(date) {
  if(date) {
    return KRCorrectionFormatString(new Date(date), 'yyyy.MM.dd (EE)');
  }
}

export function fKrKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 EEEE bb h시 m분', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTShort(date) {
  if(date) {
    return format(new Date(date), 'M/d EE bb h:m', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrDateKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrDateYYYYMMKST(date) {
  if(date) {
    return formatInTimeZone(date, 'Asia/Seoul', 'yyyy년 M월');
  }
}

export function fKrDateDayKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일 EEEE', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrDeadlineDateHourKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일 EEEE bb h시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrDueDateHourKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일 H시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrTimeKST(date) {
  if(date) {
    return format(new Date(date), 'bb h시 m분', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeYMDKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd', { timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd hh:mm a', { timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeShortKST(date) {
  if(date) {
    return format(new Date(date), 'hh:mm a');
  }
}

export function fYYYYMMDD(date) {
  if (date && typeof date !== 'string') {
    return format(date, 'yyyy-MM-dd');
  }
  return ''
}

export function fYYYYMMDDKST(date) {
  if (date) {
    return formatInTimeZone(date, 'Asia/Seoul', 'yyyy-MM-dd');
  }
  return ''
}

export function fKrDateAbsoulte(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(y)}년 ${parseInt(m)}월 ${parseInt(d)}일`;
  }
}

export function fKrDateAbsoulteM(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(m)}월`;
  }
}

export function fKSTDateAbsoluteDuration(kstDate) {
  if(kstDate) {
    return kstDate.substring(0, 10).replaceAll("-", ".");
  }
}

export function fKrSendKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 EEEE bb h시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrMDEEEEKST(date) {
  if(date) {
    try {
      return format(new Date(date), 'EEEE(M월 d일)', { locale: ko, timezone: 'Asia/Seoul' });
    } catch(err) {
      console.error(err);
      return '';
    }
  }
}

export function fKrDateAbsoulteMD(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(m)}월 ${parseInt(d)}일`;
  }
}

export function fKrHourMinute(date) {
  if(date) {
    return format(new Date(date), 'p', { locale: ko, timezone: 'Asia/Seoul' });
  }
};

export function fFormatStringInKST(date, format) {
  try{
    if(date) {
      return formatInTimeZone(new Date(date), 'Asia/Seoul', format);
    }
  } catch(err) {
    console.error(err);
    return '';
  }
}

export function fYYYY_MM_DDInKST(date) {
  return fFormatStringInKST(date, 'yyyy-MM-dd');
}

export function fHH_MI_InKST(date) {
  return fFormatStringInKST(date, 'HH:mm');
};


export function fKrKSTMatchingCard(date, applyAt) {
  if(date) {
    const datestr = format(new Date(date), 'yyyy.MM.dd (EE) HH:mm', { locale: ko, timezone: 'Asia/Seoul' });
    return `${datestr} 제안 받음`;
  }
  if(applyAt) {
    const datestr = format(new Date(applyAt), 'yyyy.MM.dd (EE) HH:mm', { locale: ko, timezone: 'Asia/Seoul' });
    return `${datestr} 지원함`;
  }
  return "";
};

export function fKrKSTMatchingCardMobile(date, applyAt) {
  if(date) {
    let diff = new Date().getTime() - new Date(date).getTime();
    if (diff < 0) {
      return "";
    }
    let diffInMinutes = diff / (1000 * 60);
    let diffInHours = diff / (1000 * 3600);
    let diffInDays = diff / (1000 * 3600 * 24);
    const diffDaysNumber = Number.parseInt(diffInDays);
    const diffHoursNumber = Number.parseInt(diffInHours);
    const diffMinutesNumber = Number.parseInt(diffInMinutes);
    if(diffDaysNumber > 0) {
      return `${diffDaysNumber}일 전 제안 받음`;
    } else if(diffHoursNumber > 0) {
      return `${diffHoursNumber}시간 전 제안 받음`;
    } else if(diffMinutesNumber > 0) {
      return `${diffMinutesNumber}분 전 제안 받음`;
    } else if(diffMinutesNumber === 0) {
      return `방금 제안 받음`;
    }
  }
  if(applyAt) {
    let diff = new Date().getTime() - new Date(applyAt).getTime();
    if (diff < 0) {
      return "";
    }
    let diffInMinutes = diff / (1000 * 60);
    let diffInHours = diff / (1000 * 3600);
    let diffInDays = diff / (1000 * 3600 * 24);
    const diffDaysNumber = Number.parseInt(diffInDays);
    const diffHoursNumber = Number.parseInt(diffInHours);
    const diffMinutesNumber = Number.parseInt(diffInMinutes);
    if(diffDaysNumber > 0) {
      return `${diffDaysNumber}일 전 지원함`;
    } else if(diffHoursNumber > 0) {
      return `${diffHoursNumber}시간 전 지원함`;
    } else if(diffMinutesNumber > 0) {
      return `${diffMinutesNumber}분 전 지원함`;
    } else if(diffMinutesNumber === 0) {
      return `방금 지원함`;
    }
  }
  return "";
};
